import { ProfileMemberData } from "../typings/member";

//Action Types
export const SET_PROFILE_MEMBER_DATA = "setProfileMemberData";
export const RESET_PROFILE_MEMBER_DATA = "resetMemberProfileData";

//Action creators
export const setProfileMemberData = (data: Partial<ProfileMemberData>) => ({
    type: SET_PROFILE_MEMBER_DATA,
    data
});

export const resetMemberProfileData = () => ({
    type: RESET_PROFILE_MEMBER_DATA,
});

const initialState: ProfileMemberData = {
    needToRefresh: false,
    doubleMatch: {
        doubleMatchType: 1,
        bounakirMessage: "",
        isSentMeSticker: false

    },
    showNoProfilePictureModal: true,

}

//Reducer


export default function reducer(state = initialState, action: any) {
    switch (action.type) {
        case SET_PROFILE_MEMBER_DATA:
            return { ...state, ...action.data };
        case RESET_PROFILE_MEMBER_DATA:
            return { ...initialState };
        default:
            return state;
    }
}